export const isCompanyArchived = (company) => company?.relation?.isArchived === true

// A local directory ID identifies exactly one entry; a shared master remains
// usable when another alias in this tenant is active.
export const findArchivedCompany = (companies, companyId) => {
  const local = companies?.find((company) => company.id === companyId)
  if (local) return isCompanyArchived(local) ? local : null
  const aliases = companies?.filter((company) => company.relation?.relatedCompanyMasterId === companyId) ?? []
  return aliases.length && aliases.every(isCompanyArchived) ? aliases[0] : null
}

export const getCompanyProblem = (error) => {
  let body = error?.body ?? error?.result
  if (typeof body === "string") {
    try { body = JSON.parse(body) } catch { return null }
  }
  if (!body || (error?.status ?? body.status) !== 409) return null
  const problem = { ...body, ...body.extensions }
  return ["company_vat_conflict", "company_archived"].includes(problem.code) ? problem : null
}

export const replaceCachedCompany = (store, company) => {
  if (!company?.id || !Array.isArray(store?.records)) return
  const index = store.records.findIndex((entry) => entry.id === company.id)
  if (index < 0) store.records.push(company)
  else store.records.splice(index, 1, company)
}

export const normalizeCompanyVat = (vat) => String(vat ?? "").replace(/[^A-Za-z0-9]/g, "").toUpperCase()

export const companyVatNeedsCheck = (company, original) => !company.isPrivateConsumer && (
  !original?.id ||
  original.isPrivateConsumer === true ||
  normalizeCompanyVat(company.vatNumber) !== normalizeCompanyVat(original.vatNumber)
)

export const findCompanyVatMatches = (companies, company, original) => {
  const vat = normalizeCompanyVat(company.vatNumber)
  if (!vat || !companyVatNeedsCheck(company, original)) return []
  return (companies ?? [])
    .filter((entry) => entry.id !== company.id && entry.isPrivateConsumer !== true && normalizeCompanyVat(entry.vatNumber) === vat)
    .map((entry) => ({ companyId: entry.id, name: entry.name, isArchived: isCompanyArchived(entry) }))
}
